import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { timeout } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NXIGridExportServiceDefinition } from '../../models/common/nxi-grid-export-service-definition';


const SERVICE_CALL_TIMEOUT = 300000;

@Injectable()
export class GridExportService {

    public exportServiceUrl: string;
    public settingsDetailsServiceUrl: string;

    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter, private snackBar: MatSnackBar, public dialog: MatDialog) {
        logService.info('GridExportService : constructor Initializing');
        this.exportServiceUrl = this.serviceRouter.getServiceRouteURL(NXIGridExportServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } });
    }


    public initiateExportCallWithJSONData(jsonString: string, exportConfig: any, downloadExtension: string, fileName?: string): void {
        let headerObj = new HttpHeaders();
        headerObj.append('Content-Type', 'application/x-www-form-urlencoded');
        let params = new HttpParams();
        params = params.append('gridJSONData', this.encodeGridData(jsonString, exportConfig));
        params = params.append('exportConfig', JSON.stringify(exportConfig));

        let url = '';
        if (downloadExtension === 'pdf') {
            url = this.exportServiceUrl + '/gridjsondatatopdf';
        } else if (downloadExtension === 'xlsx') {
            url = this.exportServiceUrl + '/gridjsondatatoexcel';
        }

        this.http.post(url, params, { headers: headerObj, responseType: 'blob', observe: 'response' })
            .pipe(timeout(SERVICE_CALL_TIMEOUT)).subscribe((resp: HttpResponse<Blob>) => {
                this.handleExportResponse(resp, exportConfig, downloadExtension, fileName);
            },
                error => {
                    this.openErrorDialog();
                    this.logService.error('ERROR: GridExportService - initiateExportCall : ', error);
                });
    }


    private encodeGridData(gridData: any, exportConfig: any): any {
        let returnData = gridData;
        if (exportConfig && exportConfig['dataEncodedWithBase64'] && typeof exportConfig['dataEncodedWithBase64'] === 'string') {
            let base64Encode = exportConfig['dataEncodedWithBase64'].toUpperCase();
            if (base64Encode === 'YES' || base64Encode === 'TRUE') {
                returnData = btoa(gridData);
            }
        } else {
            returnData = btoa(gridData);
        }
        return returnData;
    }

    private handleExportResponse(resp: HttpResponse<Blob>, exportConfig: any, downloadExtension: string, fileName?: string) {
        this.snackBar.dismiss();
        this.logService.log('Success: GridExportService - initiateExportCall');
        let downloadElement = document.createElement('a');
        downloadElement.setAttribute('href', window.URL.createObjectURL(resp.body));
        downloadElement.setAttribute('download', this.getFileName(resp.headers, fileName, downloadExtension, exportConfig) );
        downloadElement.click();
    }

    private getFileName( headers: HttpHeaders, fileName: string, downloadExtension: string , exportConfig: any): string {
        let returnfileName = null;
        returnfileName = this.checkForContentDispo(headers, returnfileName);
        if (returnfileName === null) {
            if (fileName === undefined || fileName === null || fileName === '') {
                if (exportConfig && exportConfig['title']) {
                    returnfileName = exportConfig['title'];
                    if (exportConfig['contextValue']) {
                        returnfileName = returnfileName + '_' + exportConfig['contextValue'];
                    }
                } else {
                    returnfileName = 'exportfile';
                }
            } else {
                returnfileName = fileName;
            }
            returnfileName = returnfileName.replace(/ /g, '+');
            returnfileName += ('.' + downloadExtension);
        }
        return returnfileName;
    }

    private checkForContentDispo(headers: HttpHeaders, returnfileName: any) {
        if (headers && headers.get('Content-Disposition') !== null &&  headers.get('Content-Disposition') !== undefined) {
            headers.get('Content-Disposition').split(';').forEach((i) => {
                if (i.includes('filename') && i.split('=').length === 2) {
                    returnfileName = i.split('=')[1].replace(/"/g, '');
                }
            });
        }

        return returnfileName;
    }

    openErrorDialog(): void {
        this.snackBar.dismiss();
    }




}
